<template>
  <div class="section" id="whatwedo">
    <div class="left">
      <div class="left_wrap">
        <div class="title">{{ data.text_1 }}</div>
        <div class="sub_title">
          {{ data.text_2 }}
        </div>
      </div>
    </div>
    <div class="right">
      <div class="right_wrap">
        <div class="sub_section">
          <div class="title">{{ data.text_3 }}</div>
          <div class="sub_title">
            {{ data.text_4 }}
          </div>
        </div>
        <div class="sub_section">
          <div class="title">{{ data.text_5 }}</div>
          <div class="sub_title">
            {{ data.text_6 }}
          </div>
        </div>
        <div class="subsection">
          <div class="title">{{ data.text_7 }}</div>
          <div class="sub_title">
            {{ data.text_8 }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    data: {
      text_1: "What we do",
      text_2: `We’re in this together, from your first day of classes to your first
            day on the job and beyond.`,
      text_3: "Designed for student success",
      text_4: `you can be in a new career as a Web Developer, iOS Developer, or
              Data Scientist by this time next year.`,
      text_5: "Pay nothing upfront",
      text_6: `You don't pay tuition until you land a job making at least $50k a
              year.`,
      text_7: "We help get you hired",
      text_8: `We’ll help you hunt down jobs, nail interviews, and negotiate
              salary.`,
    },
  },
};
</script>
<style>
.section#whatwedo {
  display: flex;
  padding: 1rem 2.5rem;
  min-height: calc(100vh - 75px);
}
.section#whatwedo .left {
  width: 100%;
  display: flex;
  justify-content: center;
}
.section#whatwedo .left .left_wrap {
  padding: 0rem 5rem 0rem 5rem;
  padding-top: 8rem;
}
.section#whatwedo .left .title {
  font-size: 3rem;
  font-family: "Volkhov", serif;
  font-weight: 400;
}
.section#whatwedo .left .sub_title {
  margin-top: 1rem;
  margin-bottom: 2.2rem;
  font-size: 1.1rem;
  line-height: 2rem;
}
.section#whatwedo .right {
  width: 100%;
  display: flex;
  justify-content: center;
}
.section#whatwedo .right .sub_section {
  margin-bottom: 3rem;
}
.section#whatwedo .right_wrap {
  padding: 0rem 5rem 0rem 5rem;
  padding-top: 8rem;
}
.section#whatwedo .right .title {
  font-size: 1.8rem;
  color: #ea3c49;
  font-family: "Volkhov", serif;
  font-weight: 400;
}
.section#whatwedo .right .sub_title {
  margin-top: 0.8rem;
  margin-bottom: 2.2rem;
  font-size: 1.1rem;
  line-height: 2rem;
}
</style>